(function ($) {
  $(function () {
    const map = document.querySelector('#js-filterable-map');

    if (map == null) {
      return;
    }

    //Default variables
    var selectedAges = [];
    var selectedTypes = [];

    const places = localize.map_data;
    const pins = $('.js-map-location');
    const infoBox = $('.js-map-infobox');
    const keywordInput = $('.js-live-search');
    const listItemTitle = $('.js-place-name');
    const modal = $('.js-program-filter-modal');
    const primaryListItem = $('.js-map-primary-list-item');

    //Create the draggable map effect on the SVG
    const panzoom = Panzoom(map, {
      maxScale: 1199 >= window.innerWidth ? 7 : 5,
      minScale: 1199 >= window.innerWidth ? 2 : 1,
      contain: 1199 >= window.innerWidth ? 'outside' : ''
    });

    map.addEventListener('panzoomchange', function (e) {
      if ($(window).width() > 1199) {
        if (window.selectedPin) {
          $('.js-map-infobox .js-map-list-item').remove();
          window.selectedPin.find('path, circle').first().removeAttr('style')
        }
      }
    });

    //Option to zoom in the SVG
    $('#zoomIn').on('click', function () {
      panzoom.zoomIn({ animate: true })
    });

    $('#zoomOut').on('click', function () {
      panzoom.zoomOut({ animate: true })
    });


    //Function to filter places based on selected ages and types and keyword filter
    function filterPlaces() {
      var anyPlaceVisible = false;

      places.forEach(function (place) {
        var place_id = place.place_id;
        var programs = place.programs;
        var showPlace = false;

        programs.forEach(function (program) {
          var programAgeIds = program.age_id.map(String);
          var programTypeIds = program.type_id.map(String);

          if (
            (selectedAges.length === 0 || selectedAges.some(age => programAgeIds.includes(age))) &&
            (selectedTypes.length === 0 || selectedTypes.some(type => programTypeIds.includes(type)))
          ) {
            showPlace = true;
          }
        });

        // Check if the place matches the keyword filter
        var keywordMatch = true;
        if (keywordInput.val() !== "") {
          var placeTitle = $(`.js-map-primary-list-item[data-id="${place_id}"] .js-place-name`).text().toLowerCase();
          keywordMatch = placeTitle.includes(keywordInput.val().toLowerCase());
        }

        if (showPlace && keywordMatch) {
          anyPlaceVisible = true;
          if (place_id) {
            $(document).find(`#js-filterable-map g#${place_id}`).show();
            $(`.js-map-primary-list-item[data-id="${place_id}"]`).show();
            if (place_id == '14A' || place_id == '14B') {
              $(`#js-filterable-map g#14-number`).show();
            }

            if (place_id == '2A' || place_id == '2-A' || place_id == '2B' || place_id == '2-B') {
              $(`#js-filterable-map g#2-number`).show();
            }
          }
        } else {
          if (place_id) {
            $(document).find(`#js-filterable-map g#${place_id}`).hide();
            $(`.js-map-primary-list-item[data-id="${place_id}"]`).hide();
          }
        }
      });

      // Hide items without data-id
      $('.js-map-primary-list-item[data-id=""').hide();

      // Hide the container if no places are visible
      if (!anyPlaceVisible) {
        $('.map-list-item_wrapper').hide();
      } else {
        $('.map-list-item_wrapper').show();
      }
    }

    //Function to filter places by age category
    function filterPlacesByAge(ageId = null) {
      if (window.selectedPin) {
        window.selectedPin.find('path, circle').first().removeAttr('style')
      }
      pins.add(infoBox).not('.service').hide().removeClass('filtered-by-age');
      if (ageId != null) {
        if (!selectedAges.includes(ageId)) {
          selectedAges.push(ageId);
        } else {
          selectedAges = selectedAges.filter(e => e != ageId);
        }
      }

      if (selectedAges.length == 0 && selectedTypes.length == 0 && keywordInput.val() == "") {
        resetFilters();
        return;
      }

      filterByKeyword(keywordInput.val());
      filterPlaces();
    }

    //Function to filter places by type category
    function filterPlacesByType(typeId = null) {
      if (window.selectedPin) {
        window.selectedPin.find('path, circle').first().removeAttr('style')
      }
      pins.add(infoBox).not('.service').hide().removeClass('filtered-by-type');
      if (typeId != null) {
        if (!selectedTypes.includes(typeId)) {
          selectedTypes.push(typeId);
        } else {
          selectedTypes = selectedTypes.filter(e => e != typeId);
        }
      }

      if (selectedAges.length == 0 && selectedTypes.length == 0 && keywordInput.val() == "") {
        resetFilters();
        return;
      }

      filterByKeyword(keywordInput.val());
      filterPlaces();
    }

    //Function to filter places by keyword
    function filterByKeyword(inputValue) {
      if (window.selectedPin) {
        window.selectedPin.find('path, circle').first().removeAttr('style')
      }
      inputValue = inputValue.toLowerCase();

      pins.add(infoBox).hide().removeClass('filtered-by-keyword');

      listItemTitle.each(function () {
        var id = $(this).closest('.js-map-list-item').data('id');

        if ($(this).text().toLowerCase().includes(inputValue)) {
          if ($('.filtered-by-age').length > 0 || $('.filtered-by-type').length > 0) {
            if ($(document).find(`g#${id}`).hasClass('filtered-by-age') || $(document).find(`g#${id}`).hasClass('filtered-by-type')) {
              if (id) {
                $(`g#${id}`).show().addClass('filtered-by-keyword');
              }

              $(this).closest('.js-map-list-item').show();
            }
          } else {
            if (id) {
              $(`g#${id}`).show().addClass('filtered-by-keyword');
            }
            $(this).closest('.js-map-list-item').show();
          }

          if (id == '14A' || id == '14B') {
            $(`#js-filterable-map g#14-number`).show();
          }

          if (id == '2A' || id == '2-A' || id == '2B' || id == '2-B') {
            $(`#js-filterable-map g#2-number`).show();
          }
        } else {
          $(this).closest('.js-map-list-item').hide();
        }

        if (!inputValue) {
          $('.js-map-list-item').show();
          pins.removeClass('filtered-by-keyword');
        }
      });

      if (selectedAges.length > 0 || selectedTypes.length > 0) {
        filterPlaces();
      }
    }

    //Function to reset filters to default state
    function resetFilters() {
      $('input[type=checkbox]').prop('checked', false);
      selectedAges = [];
      selectedTypes = [];
      $('.js-map-location').show();
      keywordInput.val('');
      $('.js-map-list-item').show();
      pins.removeClass('filtered-by-keyword');

      if (window.selectedPin) {
        $('.js-map-infobox .js-map-list-item').remove();
        window.selectedPin.find('path, circle').first().removeAttr('style')
      }
    }

    //Filter by keyword
    keywordInput.on('input paste keyup', function () {
      var keyword = keywordInput.val();
      filterByKeyword(keyword);

      if (selectedAges.length > 0) {
        filterPlacesByAge(null);
      }

      if (selectedTypes.length > 0) {
        filterPlacesByType(null);
      }

      if (selectedAges.length == 0 && selectedTypes.length == 0 && keywordInput.val() == "") {
        resetFilters();
        return;
      }
    });

    //Filter by age
    $('.js-checkbox-age').on('click', function () {
      var ageId = $(this).val();
      filterPlacesByAge(ageId);

      if (selectedTypes.length > 0) {
        filterPlacesByType(null);
      }

      if (keywordInput.val() !== "") {
        var keyword = keywordInput.val();
        filterByKeyword(keyword);
      }
    });

    //Filter by type
    $(document).on('click', '.js-checkbox-type', function () {
      var typeId = $(this).val();
      filterPlacesByType(typeId);

      if (selectedAges.length > 0) {
        filterPlacesByAge(null);
      }

      if (keywordInput.val() !== "") {
        var keyword = keywordInput.val();
        filterByKeyword(keyword);
      }
    });

    primaryListItem.on('click', function (e) {
      var id = $(this).data('id').toString();
      if (id) {
        $(`#js-filterable-map g#${id}`).trigger('click');
      }

      if ($(window).width() < 1199) {
        panzoom.zoom(0)
      }
    });

    //Init infobox
    $(pins).on('click', function () {
      if (window.selectedPin) {
        window.selectedPin.find('path, circle').first().removeAttr('style')
      }

      var id = $(this).attr('id') ? $(this).attr('id') : $(this).data('id');
      var selectedPlace = places.find(e => e.place_id == id);

      if (selectedPlace) {
        window.selectedPin = $(`#js-filterable-map #${id}`);

        var infoBoxContent =
          `<div class="js-map-list-item map--list-item" data-id="${selectedPlace.place_id}">
            <img src="${localize.themeurl}/assets/img/svg/modal-close-x.svg" alt="" class="js-remove-selection remove-selection">
            <div class="name__wrapper">
                <img class="image__pin" src="${localize.themeurl}/assets/img/svg/pin.svg" alt="">
                <p class="place-name">${selectedPlace.place_name}</p>
                </div>
                <p class="place__id">Stand: <strong>${selectedPlace.place_id}</strong></p>
                ${selectedPlace.description > 0 ? `<p class="place__description">${selectedPlace.description}</p>` : ``} 
               ${selectedPlace.place_term_count > 0 ? `<a class="go-to-places" href="${selectedPlace.place_permalink}">Programok</a>` : ``} 
          </div>`;

        $('.js-map-primary-filter, .js-toggle-primary-filter').removeClass('active');

        infoBox.html(infoBoxContent);

        window.selectedPin.find('path, circle').first().css('fill', '#ffcf11')


        if ($(window).width() > 1199) {
          infoBox.css({
            top: selectedPin.offset().top + 30,
            left: selectedPin.offset().left - 120,
            display: 'block'
          });

        } else {
          infoBox.css({
            bottom: '160px',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'block'
          });
        }
      }
    });

    //Clear infobox
    $(document).on('click', '.js-remove-selection', function () {
      $(this).parent().remove();
      if (window.selectedPin) {
        window.selectedPin.find('path, circle').first().removeAttr('style')
      }
    });

    //Toggle primary filter on tablet, mobile
    $('.js-toggle-primary-filter').on('click', function () {
      $('.js-map-primary-filter, .js-toggle-primary-filter').toggleClass('active');
    });

    $('.js-checkbox-filter-accordion').on('click', function () {
      $(this).next('.js-checkbox-filter').toggleClass('active');
    });

    $('.js-init-program-filter-modal').on('click', function () {
      modal.addClass('is-active');
    });

    $('.js-close-program-filter-modal, .js-checkbox-filter-show-programs').on('click', function (e) {
      modal.removeClass('is-active');
    });

    $('.js-checkbox-filter-accordion').on('click', function () {
      $(this).next('.js-checkbox-filter').toggleClass('is-visible');
    });

    $('.js-init-program-list-modal').on('click', function () {
      $('.js-map-primary-filter').toggleClass('active');
    });

    $('.js-reset-filters').on('click', function (e) {
      e.preventDefault();
      resetFilters();
      modal.removeClass('is-active')
    })
  });
})(jQuery);
